export const API_BASE_URL_VERSIONED = `${process.env.REACT_APP_API_BASE_URL}/${process.env.REACT_APP_API_VERSION}`;
export const APP_VERSION = process.env.REACT_APP_VERSION.replace("-", "");
